const USER_STORAGE_KEY = "userStorageKey";

const setLocalUser = (newUser) => {
	console.log("In set Local user");
	console.log(newUser);
	localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(newUser));
};

const getLocalUser = () => {
	const savedUser = localStorage.getItem(USER_STORAGE_KEY);
	return savedUser ? JSON.parse(savedUser) : undefined;
};

const deleteLocalUser = () => {
	localStorage.removeItem(USER_STORAGE_KEY);
};
export { setLocalUser, getLocalUser, deleteLocalUser };
